import React from "react"
import {TextModel} from "models/Text"
import MobileTitle from "../../components"

export interface StandardFiltersMobileTitleProps {
    text: TextModel
}

const StandardFiltersMobileTitle = ({text}: StandardFiltersMobileTitleProps) => {
    return (
        <MobileTitle variant="subtitle2" component="h1">
            {text.labels.filtersMobileTitle}
        </MobileTitle>
    )
}

export default StandardFiltersMobileTitle
